




















































import { Component, Vue, Prop } from 'vue-property-decorator';
import DossierApi from '@/store/api/DossierApi';
import Snackbar from '@/components/shared/Snackbar.vue';
import { IDossierOutboundDeliveryNote } from '@/store/models/IDossierOutboundDeliveryNotes';

@Component({ components: { Snackbar } })
export default class DossierOutboundsDeliveryNotes extends Vue {
  @Prop({ type: String, required: true }) inboundCode!: string;
  @Prop({ type: String, required: true }) idCompany!: string;

  dossierApi = new DossierApi();
  groupedOutboundsDeliveryNotes: any[] = [];
  expanded: any[] = [];
  loadingOutboundsDeliveryNotes = false;

  // Cabeceras principales
  outboundsDeliveryNotesHeaders = [
      { text: 'Warehouse', value: 'warehouseName' },
      { text: 'Customer', value: 'customer' },
      { text: 'Code', value: 'code' },
      { text: 'Date Out', value: 'dateOut' }
  ];

  // Cabeceras del detalle expandido
  outboundsDeliveryNotesDetailHeaders = [
      { text: 'Good', value: 'goodName' },
      { text: 'Pallet Id', value: 'idPallet' },
      { text: 'Pallet Type', value: 'palletType' },
      { text: 'Cases/Pallet', value: 'casesPerPallet' },
      { text: 'Total Cases', value: 'totalCases' },
      { text: 'Goods/Case', value: 'goodsPerCase' },
      { text: 'Total Goods', value: 'totalGoods' },
      { text: 'Weight', value: 'weight' },
      { text: 'Best Before', value: 'bestBeforeDate' },
      { text: 'Pallet Type', value: 'palletType' },
      { text: 'Cases/Pallet', value: 'casesPerPallet' },
      { text: 'Total Cases', value: 'totalCases' },
      { text: 'Goods/Case', value: 'goodsPerCase' },
      { text: 'Total Goods', value: 'totalGoods' },
      { text: 'Weight', value: 'weight' },
      { text: 'Best Before', value: 'bestBeforeDate' }
  ];

  async mounted() {
      await this.loadOutboundsDeliveryNotes();
  }

  async loadOutboundsDeliveryNotes() {
      if (!this.inboundCode) return;
      this.loadingOutboundsDeliveryNotes = true;

      try {
          // 🔹 Llamada al API
          const data: IDossierOutboundDeliveryNote[] =
            await this.dossierApi.DossierReadOutboundsDeliveryNotes(this.inboundCode);

          // 🔹 Agrupamos por idOutboundDeliveryNote
          this.groupedOutboundsDeliveryNotes = Object.values(
              data.reduce((acc: any, curr: IDossierOutboundDeliveryNote) => {
                  const key = curr.idOutboundDeliveryNote || curr.code;

                  if (!acc[key]) {
                      acc[key] = {
                          rowKey: key,
                          idOutboundDeliveryNote: curr.idOutboundDeliveryNote,
                          companySource: curr.companySource,
                          companyDestination: curr.companyDestination,
                          warehouseName: curr.warehouseName,
                          customer: curr.customer,
                          code: curr.code,
                          dateOut: curr.dateOut,
                          totalCases: 0,
                          totalGoods: 0,
                          details: [] as any[]
                      };
                  }

                  acc[key].details.push({
                      goodName: curr.goodName,
                      idPallet: curr.idPallet,
                      palletType: curr.palletType,
                      casesPerPallet: curr.casesPerPallet,
                      totalCases: curr.totalCases,
                      goodsPerCase: curr.goodsPerCase,
                      totalGoods: curr.totalGoods,
                      weight: curr.weight,
                      bestBeforeDate: curr.bestBeforeDate
                  });

                  acc[key].totalCases += curr.totalCases || 0;
                  acc[key].totalGoods += curr.totalGoods || 0;

                  return acc;
              }, {})
          );

          console.log("📦 Grouped Outbounds Delivery Notes:", this.groupedOutboundsDeliveryNotes);
      } catch (err) {
          console.error("❌ Error loading Outbounds Delivery Notes:", err);
      } finally {
          this.loadingOutboundsDeliveryNotes = false;
      }
  }

  formatDate(dateStr: string) {
      if (!dateStr) return '';
      return new Date(dateStr).toLocaleDateString();
  }
}
